// Dashboard Users growth page translations (pt-BR), loaded into dashboard.users.growth by ../pt-BR.users.js
module.exports = {
  menu: "Crescimento",
  title: "Crescimento de Utilizadores",
  description: "Novos utilizadores no período e evolução da base.",
  kpis: {
    newUsers: "Novos no período",
    perDay: "Novos por dia (média)",
    perWeek: "Novos por semana (média)",
    total: "Total de utilizadores",
  },
  info: {
    newUsers: "Contas criadas no período.\nFonte: Firebase (índice de perfis).",
    perDay: "Média de contas criadas por dia no período.\nFonte: Firebase (índice de perfis).",
    perWeek: "Média de contas criadas por semana no período.\nFonte: Firebase (índice de perfis).",
    total: "Contas registadas no último dia do período.\nFonte: Firebase (índice de perfis).",
  },
  hints: {
    oneDay: "período de apenas 1 dia",
    shorterThan7: "período inferior a 7 dias",
    total: "+{value} no período",
  },
  modals: {
    newUsers: {
      title: "Novos utilizadores",
    },
  },
  panels: {
    newUsers: "Novos utilizadores por {gran}",
    windows: "Comparação com períodos anteriores",
    windowsNote: "Cada barra tem a mesma duração do período selecionado; a verde, o período atual.",
    weekday: "Novos por dia da semana (média)",
    total: "Total acumulado por {gran}",
    table: "Crescimento percentual por indicador",
  },
  weekdays: {
    mon: "Segunda-feira",
    tue: "Terça-feira",
    wed: "Quarta-feira",
    thu: "Quinta-feira",
    fri: "Sexta-feira",
    sat: "Sábado",
    sun: "Domingo",
  },
  weekdaysShort: {
    mon: "Seg",
    tue: "Ter",
    wed: "Qua",
    thu: "Qui",
    fri: "Sex",
    sat: "Sáb",
    sun: "Dom",
  },
  table: {
    columns: {
      indicator: "Indicador",
      current: "Atual",
      previous: "Anterior",
      change: "Variação",
    },
    rows: {
      newUsers: "Novos utilizadores",
      installs: "Instalações",
      active: "Utilizadores ativos (média diária)",
      deleted: "Perfis apagados",
      google: "Registos via Google",
      apple: "Registos via Apple",
    },
  },
  panelInfo: {
    newUsers: "Contas criadas em cada intervalo.\nFonte: Firebase (índice de perfis).",
    windows: "Contas criadas neste período e nos anteriores de igual duração.\nFonte: Firebase (índice de perfis).",
    weekday: "Média de contas criadas em cada dia da semana no período.\nFonte: Firebase (índice de perfis).",
    total: "Contas registadas no fim de cada intervalo.\nFonte: Firebase (índice de perfis).",
    table: "Variação de cada indicador face ao período anterior.\nFonte: Firebase (índice de perfis: novos, apagados, Google e Apple) e Google Analytics (instalações e ativos; sem ele, os ativos vêm do Firebase: registo de atividade).",
  },
};
